import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class DomesticSearchProxy extends ProxyBase {
  getDomesticSearchDetail(params) {
    return this.get('detail', params)
  }
}

export default new DomesticSearchProxy('DomesticSearch/')
